export const getApiUrl = (): string => {
  // @ts-ignore Typescript doesn't understand import.meta.env, it comes from vitejs
  return import.meta.env.MODE === "development" ? "http://localhost:4000" : "";
};
